import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TableModel } from 'src/app/models/table.model';
import { Observable } from 'rxjs';
import { PagedGettyOrderDetail } from '../models/paged.getty.order.detail';
import { GettyOrderDetailModel } from '../models/getty.order.detail.model';
import { AddGettyOrderModel } from 'src/app/models/add.getty.order.model';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { GettyOrderDetailFilterModel } from '../models/getty.order.detail.filter.model';
import { GettySelectListItemModel } from '../models/getty.select.list.item.model';

@Injectable()
export class GettyOrderService {

    constructor(private http: HttpClient) { }

    add(model: AddGettyOrderModel) {
        return this.http.post(`${environment.apiUrl}/api/admin/gettyorder/add`, model);
    }

    getMappingWithLocalImage(model: Array<GettyOrderDetailModel>) {
        return this.http.post(`${environment.apiUrl}/api/admin/gettyorder/mapping-with-local-image`, model);
    }

    list(tableModel: TableModel): Observable<PagedGettyOrderDetail> {
        let url = `${environment.apiUrl}/api/admin/gettyorder/list`;
        const queryParams = [];
        const tempArr = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&') + '&' + tempArr.join('&');
        }
        return this.http.get<PagedGettyOrderDetail>(url);
    }

    details(filterModel: GettyOrderDetailFilterModel, tableModel: TableModel, gettyOrderId: number): Observable<PagedGettyOrderDetail> {
        let url = `${environment.apiUrl}/api/admin/gettyorder/detail/${gettyOrderId}`;
        const queryParams = [];
        const tempArr = [];
        if (filterModel) {
            tempArr.push(`userId=${filterModel.userId}`);
        }
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&') + '&' + tempArr.join('&');
        }
        return this.http.get<PagedGettyOrderDetail>(url);
    }

    getPhotographerNameList = () => this.http.get<Array<SelectListItemModel>>
        (`${environment.apiUrl}/api/admin/gettyorder/list-photographer-name`)

    search(fileName: string): Observable<Array<GettySelectListItemModel>> {
        return this.http.get<Array<GettySelectListItemModel>>(`${environment.apiUrl}/api/admin/gettyorder/search/${fileName}`);
    }

    imageUrl(imageId: number): Observable<any> {
        return this.http.get(`${environment.apiUrl}/api/admin/gettyorder/image-url/${imageId}`);
    }

}
